export const AUTH_EXPIRED = 'auth/expired';

export const authExpired = () => ({ type: AUTH_EXPIRED } as const);
